import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface InternalOrganization {
    id: string;
    name: string;
    organizationMode: 'full-time' | 'invoicing' | 'inventory';
    invoicingEnabled: boolean;
    inventoryEnabled: boolean;
}

interface InternalOrganizationsResponse {
    currentOrganizationId: string;
    organizations: InternalOrganization[];
}

const getInternalOrganizations = async (sessionId: string): Promise<InternalOrganizationsResponse> => {
    const { data } = await axios.get<InternalOrganizationsResponse>(`${API_URL}/internal/organizations`, {
        headers: { Authorization: sessionId },
    });
    return data;
};

/** Every customer org a Yaxle employee can switch into. Disabled for everyone else. */
export const useInternalOrganizations = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const sessionContext = useContext(SessionContext);
    const sessionId = sessionContext?.sessionId ?? null;
    const isInternal = sessionContext?.isAuthenticated === true && sessionContext.isInternal;

    return useQuery({
        queryKey: ['/internal/organizations', sessionId],
        queryFn: () => getInternalOrganizations(sessionId!),
        enabled: enabled && isInternal && !!sessionId,
        staleTime: 5 * 60 * 1000,
    });
};
